import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MAT_DATE_LOCALE, MatLineModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {NgxMaskDirective} from 'ngx-mask';
import {NgxSpinnerModule} from 'ngx-spinner';

import {UiModule} from '@ui/ui.module';

import {CardSFormDialogComponent} from '@atmi/shared/card-s-form-dialog/card-s-form-dialog.component';
import {ArcCardsComponent} from './arc-cards/arc-cards.component';
import {BaseCardsComponent} from './base-cards/base-cards.component';
import {BasePickerDialogComponent} from './base-picker-dialog/base-picker-dialog.component';
import {BibCardsComponent} from './bib-cards/bib-cards.component';
import {CardActionsComponent} from './card-actions/card-actions.component';
import {CardDialogComponent} from './card-dialog/card-dialog.component';
import {CardInfoComponent} from './card-info/card-info.component';
import {AttachmentsManagerComponent} from './card-manager/attachments-manager/attachments-manager.component';
import {ChildrenCardsManagerComponent} from './card-manager/children-cards-manager/children-cards-manager.component';
import {IccdFomrIddDirective} from './card-manager/iccd-manager/iccd-form-id.directive';
import {IccdManagerComponent} from './card-manager/iccd-manager/iccd-manager.component';
import {InfoCardManagerComponent} from './card-manager/info-card-manager/info-card-manager.component';
import {MovementssManagerComponent} from './card-manager/movementss-manager/movementss-manager.component';
import {RelationsManagerComponent} from './card-manager/relations-manager/relations-manager.component';
import {RestorationsManagerComponent} from './card-manager/restorations-manager/restorations-manager.component';
import {SourceArcManagerComponent} from './card-manager/source-arc-manager/source-arc-manager.component';
import {SourceBibManagerComponent} from './card-manager/source-bib-manager/source-bib-manager.component';
import {CardsDManagerComponent} from './cards-d-manager/cards-d-manager.component';
import {CardsDComponent} from './cards-d/cards-d.component';
import {CardsDialogComponent} from './cards-dialog/cards-dialog.component';
import {CardsFManagerComponent} from './cards-f-manager/cards-f-manager.component';
import {CardsFComponent} from './cards-f/cards-f.component';
import {CardsMiManagerComponent} from './cards-mi-manager/cards-mi-manager.component';
import {CardsMiComponent} from './cards-mi/cards-mi.component';
import {CardsOaManagerComponent} from './cards-oa-manager/cards-oa-manager.component';
import {CardsOacComponent} from './cards-oac/cards-oac.component';
import {CardsSManagerComponent} from './cards-s-manager/cards-s-manager.component';
import {CardsSComponent} from './cards-s/cards-s.component';
import {CardsSourceArcDialogComponent} from './cards-source-arc-dialog/cards-source-arc-dialog.component';
import {CardsSourceBibDialogComponent} from './cards-source-bib-dialog/cards-source-bib-dialog.component';
import {RoleDirective} from './directives/role.directive';
import {EntityActionsComponent} from './entity-actions/entity-actions.component';
import {
  ExportSettingPickerDialogComponent
} from './export-setting-picker-dialog/export-setting-picker-dialog.component';
import {BaseFiltersComponent} from './filters/base-filters/base-filters.component';
import {CardDFiltersComponent} from './filters/card-d-filters/card-d-filters.component';
import {CardFFiltersComponent} from './filters/card-f-filters/card-f-filters.component';
import {CardMiFiltersComponent} from './filters/card-mi-filters/card-mi-filters.component';
import {CardOaFiltersComponent} from './filters/card-oa-filters/card-oa-filters.component';
import {CardSFiltersComponent} from './filters/card-s-filters/card-s-filters.component';
import {SourceArchivialFiltersComponent} from './filters/source-archivial-filters/source-archivial-filters.component';
import {
  SourceBibliographicFiltersComponent
} from './filters/source-bibliographic-filters/source-bibliographic-filters.component';
import {HeaderComponent} from './header/header.component';
import {AcqFormComponent} from './iccd/acq-form/acq-form.component';
import {AggFormComponent} from './iccd/agg-form/agg-form.component';
import {AutFormComponent} from './iccd/aut-form/aut-form.component';
import {CdgFormComponent} from './iccd/cdg-form/cdg-form.component';
import {CmpFormComponent} from './iccd/cmp-form/cmp-form.component';
import {CprFormComponent} from './iccd/cpr-form/cpr-form.component';
import {DesFormComponent} from './iccd/des-form/des-form.component';
import {DtFormComponent} from './iccd/dt-form/dt-form.component';
import {EdtFormComponent} from './iccd/edt-form/edt-form.component';
import {FvcFormComponent} from './iccd/fvc-form/fvc-form.component';
import {IccdFormComponent} from './iccd/iccd-form/iccd-form.component';
import {IseFormComponent} from './iccd/ise-form/ise-form.component';
import {IsrFormComponent} from './iccd/isr-form/isr-form.component';
import {LaFormComponent} from './iccd/la-form/la-form.component';
import {LrcFormComponent} from './iccd/lrc-form/lrc-form.component';
import {MifFormComponent} from './iccd/mif-form/mif-form.component';
import {MisFormComponent} from './iccd/mis-form/mis-form.component';
import {MtcExtendedFormComponent} from './iccd/mtc-extended-form/mtc-extended-form.component';
import {MtcFormComponent} from './iccd/mtc-form/mtc-form.component';
import {NctFormComponent} from './iccd/nct-form/nct-form.component';
import {OgtFormComponent} from './iccd/ogt-form/ogt-form.component';
import {PrdFormComponent} from './iccd/prd-form/prd-form.component';
import {PrvFormComponent} from './iccd/prv-form/prv-form.component';
import {SgtFormComponent} from './iccd/sgt-form/sgt-form.component';
import {StcFormComponent} from './iccd/stc-form/stc-form.component';
import {UbfFormComponent} from './iccd/ubf-form/ubf-form.component';
import {ImageMediaDialogComponent} from './image-media-dialog/image-media-dialog.component';
import {InputPersonAutocompleteComponent} from './input-person-autocomplete/input-person-autocomplete.component';
import {
  InputVocabularyAutocompleteComponent
} from './input-vocabulary-autocomplete/input-vocabulary-autocomplete.component';
import {LinkWebFormComponent} from './link-web-form/link-web-form.component';
import {MovementDialogComponent} from './movement-dialog/movement-dialog.component';
import {FilterObjPipe} from './pipes/filter-obj.pipe';
import {HyphenPipe} from './pipes/hyphen.pipe';
import {ProjectFormComponent} from './project-form/project-form.component';
import {RestorationDialogComponent} from './restoration-dialog/restoration-dialog.component';
import {SidenavComponent} from './sidenav/sidenav.component';
import {SourceArcDialogComponent} from './source-arc-dialog/source-arc-dialog.component';
import {SourceBibDialogComponent} from './source-bib-dialog/source-bib-dialog.component';
import {TagsFormComponent} from './tags-form/tags-form.component';
import {
  VocabularyAdvancedManagerDialogComponent,
} from './vocabulary-advanced-manager-dialog/vocabulary-advanced-manager-dialog.component';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

export * from './base-picker-dialog/base-picker-dialog.component';
export * from './card-dialog/card-dialog.component';
export * from './card-manager/iccd-manager/iccd-manager.component';
export * from './card-manager/iccd-manager/iccd-manager.component';
export * from './card-manager/info-card-manager/info-card-manager.component';
export * from './cards-dialog/cards-dialog.component';
export * from './cards-source-arc-dialog/cards-source-arc-dialog.component';
export * from './cards-source-bib-dialog/cards-source-bib-dialog.component';
export * from './entity-actions/entity-actions.component';
export * from './export-setting-picker-dialog/export-setting-picker-dialog.component';
export * from './filters/base-filters/base-filters.component';
export * from './header/header.component';
export * from './iccd/acq-form/acq-form.component';
export * from './iccd/agg-form/agg-form.component';
export * from './iccd/aut-form/aut-form.component';
export * from './iccd/cdg-form/cdg-form.component';
export * from './iccd/cmp-form/cmp-form.component';
export * from './iccd/des-form/des-form.component';
export * from './iccd/dt-form/dt-form.component';
export * from './iccd/iccd-form/iccd-form.component';
export * from './iccd/isr-form/isr-form.component';
export * from './iccd/mis-form/mis-form.component';
export * from './iccd/mtc-form/mtc-form.component';
export * from './iccd/nct-form/nct-form.component';
export * from './iccd/ogt-form/ogt-form.component';
export * from './iccd/sgt-form/sgt-form.component';
export * from './image-media-dialog/image-media-dialog.component';
export * from './movement-dialog/movement-dialog.component';
export * from './pipes/hyphen.pipe';
export * from './restoration-dialog/restoration-dialog.component';
export * from './sidenav/sidenav.component';
export * from './source-arc-dialog/source-arc-dialog.component';
export * from './source-bib-dialog/source-bib-dialog.component';
export * from './tags-form/tags-form.component';
export * from './vocabulary-advanced-manager-dialog/vocabulary-advanced-manager-dialog.component';

const components = [
  AcqFormComponent,
  AggFormComponent,
  ArcCardsComponent,
  AttachmentsManagerComponent,
  AutFormComponent,
  BaseCardsComponent,
  BaseFiltersComponent,
  BibCardsComponent,
  CardActionsComponent,
  CardDFiltersComponent,
  CardFFiltersComponent,
  CardInfoComponent,
  CardMiFiltersComponent,
  CardOaFiltersComponent,
  CardsDComponent,
  CardsDManagerComponent,
  CardsFComponent,
  CardSFiltersComponent,
  CardsFManagerComponent,
  CardsMiComponent,
  CardsMiManagerComponent,
  CardsOacComponent,
  CardsOaManagerComponent,
  CardsSComponent,
  CardsSManagerComponent,
  CdgFormComponent,
  ChildrenCardsManagerComponent,
  CmpFormComponent,
  CprFormComponent,
  DesFormComponent,
  DtFormComponent,
  EdtFormComponent,
  EntityActionsComponent,
  FvcFormComponent,
  HeaderComponent,
  IccdFormComponent,
  IccdManagerComponent,
  InfoCardManagerComponent,
  InputPersonAutocompleteComponent,
  InputVocabularyAutocompleteComponent,
  IseFormComponent,
  IsrFormComponent,
  LaFormComponent,
  LinkWebFormComponent,
  LrcFormComponent,
  MifFormComponent,
  MisFormComponent,
  MovementssManagerComponent,
  MtcExtendedFormComponent,
  MtcFormComponent,
  NctFormComponent,
  OgtFormComponent,
  PrdFormComponent,
  ProjectFormComponent,
  PrvFormComponent,
  RelationsManagerComponent,
  RestorationsManagerComponent,
  SgtFormComponent,
  SidenavComponent,
  SourceArchivialFiltersComponent,
  SourceArcManagerComponent,
  SourceBibliographicFiltersComponent,
  SourceBibManagerComponent,
  StcFormComponent,
  TagsFormComponent,
  UbfFormComponent,
];

const directives = [
  IccdFomrIddDirective,
  RoleDirective,
];

const entryComponents = [
  BaseFiltersComponent,
  CardDFiltersComponent,
  CardFFiltersComponent,
  CardMiFiltersComponent,
  CardOaFiltersComponent,
  CardSFiltersComponent,
  SourceArchivialFiltersComponent,
  SourceBibliographicFiltersComponent,
];

const dialogs = [
  BasePickerDialogComponent,
  CardDialogComponent,
  CardsDialogComponent,
  CardSFormDialogComponent,
  CardsSourceArcDialogComponent,
  CardsSourceBibDialogComponent,
  ExportSettingPickerDialogComponent,
  ImageMediaDialogComponent,
  MovementDialogComponent,
  RestorationDialogComponent,
  SourceArcDialogComponent,
  SourceBibDialogComponent,
  VocabularyAdvancedManagerDialogComponent,
];

const pipes = [
  HyphenPipe,
  FilterObjPipe,
];

const material = [
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatPaginatorModule,
  MatSelectModule,
  MatStepperModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
];

@NgModule({
  declarations: [
    ...components,
    ...dialogs,
    ...directives,
    ...entryComponents,
    ...pipes,
  ],
  exports: [
    ...components,
    ...dialogs,
    ...directives,
    ...pipes,
  ],
    imports: [
        ...material,
        CommonModule,
        FormsModule,
        NgxSpinnerModule,
        NgSelectModule,
        //NgxMaskModule.forRoot(),
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        UiModule,
        NgxMaskDirective,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatLineModule,
    ],
  providers: [
    ...pipes,
    {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
  ],
})
export class SharedModule {
}
